import { InfoIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/components/capstone/base';
import { BannerWrapper, IconWrapper } from './CallPaneNext.styles';

// TODO: can be removed once the EventPane is rolled out to everyone and CallPaneNext is deprecated
export const DidNotCallBanner = () => {
  return (
    <BannerWrapper horizontal>
      <IconWrapper>
        <InfoIcon height="16px" width="16px" />
      </IconWrapper>
      <Text color={'background'} ml={'12px'} size={'normal'}>
        This phone number did not call 911.
      </Text>
    </BannerWrapper>
  );
};
